var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social"},[_c('a',{attrs:{"href":"https://fr.linkedin.com/in/quentinleman","target":"blank"}},[_vm._v("In")])])}]

export { render, staticRenderFns }